import isEqual from 'lodash/isEqual';
import { ThunkAction } from 'redux-thunk';

import { TRootState } from '@/redux/rootReducer';
import { TQueryParams } from '@/services/searchApiRequest';
import { IAction } from '@/utility/redux/action';

const UPDATE = 'promoQueryParams/UPDATE';

interface IUpdateAction extends IAction {
  type: typeof UPDATE;
  payload: TQueryParams;
}

type TAction = IUpdateAction;

const updateQueryParams = (payload: TQueryParams): IUpdateAction => ({
  type: UPDATE,
  payload,
});

export const initialState: TQueryParams = {};

export default function reducer(state = initialState, action: TAction) {
  switch (action.type) {
    case UPDATE:
      return action.payload;
    default:
      return state;
  }
}

export const setPromoQueryParams =
  (query: TQueryParams): ThunkAction<IUpdateAction | null, TRootState, void, IUpdateAction> =>
  (dispatch, getState) => {
    const existingParams = getState().queryParams;

    if (isEqual(existingParams, query)) {
      return null;
    }
    return dispatch(updateQueryParams(query));
  };
